type PricingItemCheckIconProps = {
  className?: string;
};

const PricingItemCheckIcon = ({ className }: PricingItemCheckIconProps) => (
  <img
    src="/img/checkIcon.svg"
    alt=""
    aria-hidden="true"
    width={20}
    height={20}
    className={className}
  />
);

export default PricingItemCheckIcon;
